import React from "react";
import { Typography } from "@mui/material";

const NavigationDrawerHeadline = ({ label, sx = {}, ...props }) => (
  <Typography variant="h6" sx={{ fontWeight: 600, ...sx }} {...props}>
    {label}
  </Typography>
);

export default NavigationDrawerHeadline;
